// Trimmed from LC2 (src/app/store/reducers/entities.js) — accounts/communities/campaigns/
// residents state and actions are ported unchanged (same shape, same setCampaigns display-
// name formatting quirk). The extraReducers tied to reviewsApi/contactListApi/teamMembers
// CRUD are commented out until those slices are ported (not needed by the two dashboard
// tables); re-enable them then.
import {createSlice} from '@reduxjs/toolkit';
// TODO(port loyaltyCloudApi reviews/contactList, coreApi residents):
// import {reviewsApi} from '../../../features/loyaltyCloudApi/reviewsSlice';
// import {residentsApi} from '../../../features/coreApi/residentsSlice';
// import {campaignsSlice} from '../../../features/actionsApi/campaignsSlice';
// import {loyaltyCloudApi} from '../../../features/loyaltyCloudApi/apiSlice';
// import {contactListApi} from '../../../features/loyaltyCloudApi/contactListSlice';

const initialState = {
    accounts: [],
    communities: [],
    campaigns: [],
    residents: [],
    reviews: [],
    teamMembers: [],
    contactLists: []
};

const entities = createSlice({
    name: 'entities',
    initialState,
    reducers: {
        setAccounts: (state, action) => {
            state.accounts = action.payload;
        },
        setCommunities: (state, action) => {
            state.communities = action.payload;
        },
        setCampaigns: (state, action) => {
            const formattedCampaigns = [];

            for (const payloadCampaign of action.payload) {
                let newCampaign = {...payloadCampaign};
                if (newCampaign.name) {
                    if (newCampaign.name.includes('StakePro')) {
                        newCampaign.status = 'Active';
                        newCampaign.display_subtype = 'StakePro';
                    } else if (newCampaign.name.includes('StakeFree') || newCampaign.name.includes('Stake Free')) {
                        newCampaign.status = 'Active';
                        newCampaign.display_subtype = 'StakeFree';
                    }
                } else if (newCampaign.subtype === 'Stake1') {
                    newCampaign.status = 'Active';
                    newCampaign.display_subtype = 'Stake1';
                }

                formattedCampaigns.push(newCampaign);
            }

            state.campaigns = formattedCampaigns.sort((a, b) => a.name - b.name);
        },
        setResidents: (state, action) => {
            state.residents = action.payload;
        },
        setTeamMembers: (state, action) => {
            state.teamMembers = action.payload;
        },
        resetContactLists: (state) => {
            state.contactLists = [];
        }
    }
    // TODO(port loyaltyCloudApi reviews/contactList, coreApi residents): re-enable once ported
    // extraReducers(builder) { ... same matchers as LC2 ... }
});

export const {setAccounts, setCommunities, setCampaigns, setResidents, setTeamMembers, resetContactLists} = entities.actions;

export default entities.reducer;
export const getAccounts = (state) => state.entities.accounts;
export const getCommunities = (state) => state.entities.communities;
export const getCampaigns = (state) => state.entities.campaigns;
export const getResidents = (state) => state.entities.residents;
export const getReviews = (state) => state.entities.reviews;
export const getTeamMembers = (state) => state.entities.teamMembers;
export const getEntitiesContactLists = (state) => state.entities.contactLists;
